import mdPage from '../../src/views/bigData/mdPage'

export default {
  mdPage:mdPage,
}